export function useAskLowerPriceForm() {
  return useFormHandler<{ message: string }>({
    schema: askLowerPriceSchema,
    action: "ask_lower_price",
  });
}
